import { cardPatterns, cardPrefixRegexes, ECardType } from '../../../utils';

export const amexMask = [
  /[1-9x]/,
  /[0-9x]/,
  /[0-9x]/,
  /[0-9x]/,
  ' ',
  /[0-9x]/,
  /[0-9x]/,
  /[0-9x]/,
  /[0-9x]/,
  /[0-9x]/,
  /[0-9x]/,
  ' ',
  /[0-9x]/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const otherMask = [
  /[1-9x]/,
  /[0-9x]/,
  /[0-9x]/,
  /[0-9x]/,
  ' ',
  /[0-9x]/,
  /[0-9x]/,
  /[0-9x]/,
  /[0-9x]/,
  ' ',
  /[0-9x]/,
  /[0-9x]/,
  /[0-9x]/,
  /[0-9x]/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /[0-9 ]/,
];

export const otherMask_19 = [
  /[1-9x]/,
  /[0-9x]/,
  /[0-9x]/,
  /[0-9x]/,
  ' ',
  /[0-9x]/,
  /[0-9x]/,
  /[0-9x]/,
  /[0-9x]/,
  ' ',
  /[0-9x]/,
  /[0-9x]/,
  /[0-9x]/,
  /[0-9x]/,
  ' ',
  /[0-9x]/,
  /[0-9x]/,
  /[0-9x]/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
];

export const identifyPotentialCardType = (
  cardNumber: string,
  predefinedType: ECardType | null,
): ECardType | null => {
  const cleaned = cardNumber.replace(/\s+/g, ''); // Remove all spaces

  if (cleaned.match(cardPatterns[ECardType.PREDEFINED])) {
    return predefinedType;
  }

  for (const [type, pattern] of Object.entries(cardPrefixRegexes)) {
    if (pattern.test(cleaned)) {
      return type as ECardType;
    }
  }

  return null;
};
